export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}

const CCY = { USD: "$", CAD: "C$", AED: "AED ", SAR: "SAR ", INR: "₹" };

export function money(amount, currency = "USD") {
  if (amount == null) return "—";
  const sym = CCY[currency] ?? "";
  try {
    return sym + Number(amount).toLocaleString(undefined, { maximumFractionDigits: 0 });
  } catch {
    return sym + amount;
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

const STATUS_MAP = {
  active: "teal", sourced: "teal", new: "teal", open: "teal", healthy: "green",
  screening: "amber", contacted: "blue", submitted: "blue", client_review: "blue",
  interviewing: "amber", interview_scheduled: "amber", interview_completed: "amber",
  in_review: "amber", pending: "amber", on_hold: "amber", watch: "amber", proposal_sent: "amber",
  qualified: "blue", final_interview: "amber", offer_pending: "amber",
  offered: "green", offer_extended: "green", offer_accepted: "green", placed: "green",
  hired: "green", paid: "green", won: "green", signed: "green", accepted: "green", completed: "green",
  rejected: "red", withdrawn: "red", lost: "red", overdue: "red", at_risk: "red", disputed: "red",
  executive: "purple", vip: "purple", strategic: "purple",
  issued: "blue", sent: "blue", partially_paid: "amber", draft: "gray",
};

export function statusClass(status = "") {
  const key = String(status).toLowerCase().replace(/\s+/g, "_");
  return `status-${STATUS_MAP[key] || "gray"}`;
}

export function label(s = "") {
  return String(s).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}
